export var Category;
(function (Category) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["All"] = "All";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Alpha"] = "Alpha";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Beta"] = "Beta";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["JensenAlpha"] = "JensenAlpha";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["BattingAverage"] = "BattingAverage";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["BestPeriod"] = "BestPeriod";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["WorstPeriod"] = "WorstPeriod";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Kurtosis"] = "Kurtosis";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["NumOfPositivePeriods"] = "NumOfPositivePeriods";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["NumOfNegativePeriods"] = "NumOfNegativePeriods";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["TotalNumOfPeriods"] = "TotalNumOfPeriods";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["LongestPositivePeriod"] = "LongestPositivePeriod";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["LongestNegativePeriod"] = "LongestNegativePeriod";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Skewness"] = "Skewness";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["DownsideMarketCaptureRatio"] = "DownsideMarketCaptureRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["UpsideMarketCaptureRatio"] = "UpsideMarketCaptureRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["DownMarketReturn"] = "DownMarketReturn";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["UpMarketReturn"] = "UpMarketReturn";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Bias"] = "Bias";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["CalendarYearReturns"] = "CalendarYearReturns";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["ExcessReturns"] = "ExcessReturns";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["ExcessReturnsAnnualised"] = "ExcessReturnsAnnualised";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["ExcessReturnsOverRF"] = "ExcessReturnsOverRF";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["ExcessReturnsOverRFAnnualised"] = "ExcessReturnsOverRFAnnualised";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["InformationRatio"] = "InformationRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["OmegaRatio"] = "OmegaRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["TrailingYearReturns"] = "TrailingYearReturns";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["TrailingQuarterReturns"] = "TrailingQuarterReturns";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["TrailingVolatility"] = "TrailingVolatility";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["CumulativeReturn"] = "CumulativeReturn";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["AnnualisedReturn"] = "AnnualisedReturn";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["RiskFreeReturns"] = "RiskFreeReturns";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["RollingAverage"] = "RollingAverage";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["SharpeRatio"] = "SharpeRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["SortinoRatio"] = "SortinoRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["TrackingError"] = "TrackingError";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["StandardDeviation"] = "StandardDeviation";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["GainDeviation"] = "GainDeviation";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["LossDeviation"] = "LossDeviation";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Drawdown"] = "Drawdown";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["CalmarRatio"] = "CalmarRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["SterlingRatio"] = "SterlingRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["TreynorRatio"] = "TreynorRatio";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["PortfolioCorrelationCovariance"] = "PortfolioCorrelationCovariance";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["PortfolioReturns"] = "PortfolioReturns";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["PortfolioExcessReturnsCorrelation"] = "PortfolioExcessReturnsCorrelation";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["Forecast"] = "Forecast";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["RSquared"] = "RSquared";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Category["SeriesSplice"] = "SeriesSplice";
})(Category || (Category = {}));
//# sourceMappingURL=Category.js.map